import { useState, createRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import loginApi from '../../apis/login-api';
import GlobalStore from '../../stores/global-store';
import elsaLogo from '../../assets/images/elsa-logo-black.svg';
import elsaloginpic from '../../assets/images/elsa-login-pic.png';
import CryptoJS from 'crypto-js';
import './Login.css';
import env from '../../utils/env';
import { storageSetItem } from '../../utils/local-storage';
import { REMEMBER_AUTH } from '../../utils/storage-keys';

function Login() {

  const { storeSession, setAffID } = GlobalStore.useContainer();
  const recaptchaRef = createRef();
  const [usernameInput, setUsernameInput] = useState('');
  const [passwordInput, setPasswordInput] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const config = env();

  const loginSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    const recaptcha = await recaptchaRef.current.executeAsync(); 
    recaptchaRef.current.reset();
    data.append('username', usernameInput);
    data.append('password', passwordInput);
    data.append('g-recaptcha', recaptcha);
    data.append('action', 'affiliate_login');
    try {
      if (usernameInput.trim() && passwordInput.trim()) {
        setIsLoading(true);
        const response = await loginApi.login(data);
        if (response.data) {
          const date = new Date();
          const dataResponse = JSON.parse(response.data);
          const userFormData = new FormData();
          userFormData.append('username', usernameInput);
          userFormData.append('action', 'get_user_by');
          const userData = await loginApi.searchUser(userFormData);
          const userID = await userData.data.user_id;
          const userMetaData = {
            avatar_url: userData.data.avatar_url,
            display_name: userData.data.display_name
          }
          const { data } = await loginApi.getAffiliateByUserID(userID);
          if (data.length && userID) {
            if (rememberMe) {
              storageSetItem(REMEMBER_AUTH, 'forever');
            }
            setAffID(data[0].affiliate_id.toString());
            const encryptedAffiliateId = CryptoJS.AES.encrypt(data[0].affiliate_id.toString(), config.affiliateToken).toString();
            storeSession(
              dataResponse.jwt_token,
              new Date(date.setDate(date.getDate() + 1)),
              encryptedAffiliateId,
              JSON.stringify(userMetaData),
              data[0].status
            );
          }
        }
      } else {
        setError({
          data: {
            error_description: 'Vui lòng nhập username/password.'
          }
        });
      }
    } catch({ response }) {
      if (response) {
        setError(JSON.parse(response?.data));
      }
      setPasswordInput('');
    }
    setIsLoading(false);
  };

  return (
    <div className="page-login">
      <div className="login-container">
        <div className="login-form">
          <div className="elsa-logo">
            <img src={elsaLogo} alt="Elsa Now" />
          </div>
          <h1 className="login-title">Chào mừng bạn đến với công cụ Affiliate của ELSA</h1>
          <p className="login-form-title">
            Đăng nhập vào tài khoản của bạn
          </p>
          <form action="/" onSubmit={loginSubmit}>
            <div className="form-group">
              <label htmlFor="username">Tên đăng nhập</label>
              <input type="text" placeholder="Tên đăng nhập" name="username" value={usernameInput} onChange={(e) => {
                setUsernameInput(e.target.value);
                setError(null);
              }} />
            </div>
            <div className="form-group">
              <label htmlFor="password">Mật khẩu</label>
              <input type="password" placeholder="Mật khẩu" name="password" value={passwordInput} onChange={(e) => {
                setPasswordInput(e.target.value);
                setError(null);
              }} />
            </div>
            { error && (
              <p className="text-danger">{error?.error_description}</p>
            )}
            {!error && (
              <p className="text-danger">Server đang bận. Xin vui lòng quay lại sau!</p>
            )}
            <p><input type="checkbox" name="rememberme" defaultChecked={rememberMe} onChange={() => setRememberMe(!rememberMe)} id="rememberme" /> <label htmlFor="rememberme">Ghi nhớ</label></p>
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={config.captchaSiteKey}
            />
            <p><button className={(isLoading ? 'is-loading ' : '') + 'common-btn'} disabled={isLoading} type="submit">Đăng nhập</button></p>
            <p><a href={`${config.apiURL}/wp-login.php?action=lostpassword`}>Quên mật khẩu</a></p>
          </form>
        </div>
        <div className="login-background">
          <div></div>
          <div className="content">
            <img src={elsaloginpic} alt="" />
            <p className="title">
              ELSA SPEAK - APP HỌC NÓI TIẾNG ANH BẰNG A.I.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login;